import { render, staticRenderFns } from "./noticeViewAllList.vue?vue&type=template&id=256e0486&scoped=true&"
import script from "./noticeViewAllList.vue?vue&type=script&lang=js&"
export * from "./noticeViewAllList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e0486",
  null
  
)

export default component.exports